import "./footer.css";
import { Link } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaYoutube } from "react-icons/fa";
import { FiPhone, FiMail } from "react-icons/fi";

const Footer = () => {
  return (
    <footer className="footer">
      {/* Main Footer */}
      <div className="footer-content">
        {/* COLUMN 1 */}
        <div className="footer-col">
          <h2>Nordic Integration Works</h2>
          <p>
            We believe in teamwork, innovation, and learning — striving each day to
            acquire new competencies and shape the future through dedication and
            collaboration.
          </p>
          <p className="contact-item">Kista - 16444, Stockholm, Sweden</p>
        </div>

        {/* COLUMN 2 */}
        <div className="footer-col">
          <h3>Our Service</h3>
          <ul>
            <li>
              <Link to="/services/consulting-service" className="footer-link">
                Consulting Services
              </Link>
            </li>
            <li>
              <Link to="/services/staffing-service" className="footer-link">
                Staffing Services
              </Link>
            </li>
            <li>
              <Link to="/services/software-service" className="footer-link">
                Software Services
              </Link>
            </li>
            <li>
              <Link to="/services/project-service" className="footer-link">
                Project Outsourcing
              </Link>
            </li>
          </ul>
        </div>

        {/* COLUMN 3 */}
        <div className="footer-col">
          <h3>WHERE TO FIND US</h3>
          <p>Nordic Integration Works</p>
          <p>Helsingörsgatan 51</p>
          <p>Kista - 16444, Stockholm, Sweden</p>
          <p>
            {/* ✅ external link → keep <a> */}
            <a href="mailto:info@noridcworks.com" className="footer-link">
              info@noridcworks.com
            </a>
          </p>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>© 2025 Nordic Integration Works. All rights reserved.</p>

        <div className="footer-links">
          <Link to="/legal/privacy-policy">Privacy Policy</Link>
          <Link to="/legal/terms-of-service">Terms of Service</Link>
          <Link to="/legal/cookie-policy">Cookie Privacy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
